import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { trackBooking, getByBookingNo, getBookingBYContainerWise } from 'store/actions'
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TrackInfo from "./components/TrackInfo";
import TrackStatus from "./components/TrackStatus";
import TrackDetails from "./components/TrackDetails";
import { useParams } from 'react-router';

const Track = () => {
    const { trackId, containerId } = useParams()
    const [data, setdata] = useState()
    const [containerNumber, setcontainerNumber] = useState(null)
    const dispatch = useDispatch()

    const bookingByNo = useSelector(state => ({
        bookingByNo: state.GetByBookingNo?.data
    }), shallowEqual)
    const containerWiseData = useSelector(state => ({
        containerWiseData: state.GetBookingBYContainerWise?.data
    }), shallowEqual)
    const track = useSelector(state => ({
        track: state.TrackBookings?.track?.data
    }))
    
    useEffect(() => {
        if (containerNumber) dispatch(trackBooking(containerNumber))
    }, [containerNumber])

    useEffect(() => {
        if (trackId && containerId) dispatch(getBookingBYContainerWise(trackId, containerId))
        else if (trackId && !containerId) dispatch(getByBookingNo(trackId))
    }, [trackId, containerId])

    useEffect(() => {
        if (trackId && containerId) setdata(containerWiseData?.containerWiseData?.booking)
        else if (trackId && !containerId) setdata(bookingByNo?.bookingByNo?.booking)
    }, [bookingByNo, containerWiseData])

    document.title = "Track | Glottis Logistics";
    return (
        <div className="page-content booking">
            <div className="container-fluid">
                <Breadcrumbs title="Bookings" dashurl="/bookings" breadcrumbItem="Track" />
                <TrackInfo data={data} trackId={trackId}  containerNumber={containerNumber}/>
                <TrackStatus data={data} trackId={trackId}  containerNumber={containerNumber} containerId={containerId} setcontainerNumber={setcontainerNumber} trackData={track} />
                <TrackDetails data={track} bookinginfo={data} />
            </div>
        </div>
    )
}

export default Track